// extracted by mini-css-extract-plugin
export default {"offerTypeList":"DesignStudioTable_offerTypeList__Qsnmb"};